import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// If you have a logo image, import it here:
import logo from "../components/Images/icon colored 7.png"; // adjust path if needed
import "./Navbar.css"; // uses same design tokens
import ThemeToggle from "../components/ThemeToggle";

const links = [
  { label: "Home", href: "/" },
  { label: "Features", href: "/features" },
  { label: "Pricing", href: "/pricing" },
  { label: "Support", href: "/support" },
  { label: "Contact", href: "/contact" },
  { label: "Download App", href: "/download" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("#top");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Track current hash for active link styling
  useEffect(() => {
    const onHashChange = () => setActive(window.location.hash || "#top");
    onHashChange();
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header
      className={`kp-navbar ${scrolled ? "is-scrolled" : ""}`}
      id="top"
      role="banner"
    >
      <div className="kp-nav-inner">
        {/* Left: Logo */}
        <a href="#top" className="kp-brand" onClick={closeMenu}>
          <img src={logo} alt="KostPadi" />
          <span>KostPadi</span>
        </a>

        {/* Desktop links */}
        <nav className="kp-nav-links" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={active === l.href ? "is-active" : ""}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Right actions (optional) */}
        <div className="kp-nav-actions">
          <a className="btn btn-ghost hide-sm" href="/features">
            Explore
          </a>
          <a className="btn btn-primary hide-sm" href="/login">
            Get Started
          </a>
          <ThemeToggle />

          {/* Hamburger (mobile) */}
          <button
            className={`kp-hamburger ${open ? "open" : ""}`}
            aria-label="Toggle menu"
            aria-expanded={open}
            onClick={() => setOpen((s) => !s)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>

      {/* Mobile drawer */}
      <AnimatePresence>
        {open && (
          <motion.nav
            className="kp-mobile-menu"
            aria-label="Mobile"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
          >
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className={active === l.href ? "is-active" : ""}
                onClick={closeMenu}
              >
                {l.label}
              </a>
            ))}

            <div className="kp-mobile-cta">
              <a
                className="btn btn-primary"
                href="#get-started"
                onClick={closeMenu}
              >
                Start Free
              </a>
              <a className="btn btn-ghost" href="#contact" onClick={closeMenu}>
                Talk to Sales
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}
